import { Component, OnInit, ViewChild  } from '@angular/core';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { NavService } from '../../../_services/_nav.service';
import { SarlaftService } from '../../../_services/sarlaft.service';
import { Table } from 'primeng/table';
import { Variable } from '../../../_models/variable-sarlaft';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { SarlaftModalSimuladorComponent } from '../sarlaft-modal-simulador/sarlaft-modal-simulador.component';
import { TipoOpcion } from '../../../_enums/enum';

@Component({
  selector: 'app-sarlaft-variables',
  templateUrl: './sarlaft-variables.component.html',
  styleUrls: ['./sarlaft-variables.component.css']
})
export class SarlaftVariablesComponent implements OnInit {

  menu: Funcionalidad = new Funcionalidad();
  columnas: any[];
  variables: Variable[] = [];
  carVariables = true;
  @ViewChild('dt', { static: true }) tabla: Table;
  busqueda: string;
  listCondiciones: any[] = [];

  constructor(
    private autServicio: AutenticacionService,
    private navServicio: NavService,
    private router: Router,
    private diaService: DialogService,
    private sarlaftServicio: SarlaftService
  ) { }

  async ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/sarlaft' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
      { field: 'variable', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_VARIABLE' ), sort: false },
      { field: 'peso', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_PESO' ), sort: false },
      { field: 'numerocondiciones', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_NUMEROCONDICIONES' ), sort: false },
      { field: 'valordefecto', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_VALORPORDEFECTO' ), sort: false },
      { field: 'determinante', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_DETERMINANTE' ), sort: false },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_HABILITADO' ), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'sarlaft.component' );
    this.tabla.filterGlobal(this.busqueda, 'contains');
    this.variables = await this.sarlaftServicio.listadorVariablesRegistradas().toPromise();
    this.carVariables = false;
  }

  crearVariable(){
    this.router.navigate(['apl/sarlaft/variables-agregar']);
  }

  verVariable( variable: Variable ) {
    this.router.navigate( [ 'apl/sarlaft/variables-detalle/' + variable.idVariableSarlaft ] );
  }

  editarVariable( variable: Variable ) {
    this.router.navigate( [ 'apl/sarlaft/variables-actualizar/' + variable.idVariableSarlaft ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'sarlaft.component', this.busqueda );
  }

  buscarValorEnEnum(valor: string): TipoOpcion | undefined {
    const enumKeys = Object.keys(TipoOpcion);

    for (const key of enumKeys) {
      if (TipoOpcion[key] === valor) {
        return TipoOpcion[key] as TipoOpcion;
      }
    }

    return undefined;
  }

  modalSimulador() {
    const modal = this.diaService.open(SarlaftModalSimuladorComponent, {
      width: 'max-content',
      closeOnEscape: false,
      closable: false,
      data: {
        listCondiciones: this.listCondiciones,
        variables: this.variables
      }
    });
    modal.onClose.subscribe((data: any) => {
    });
  }
}
